<template>
  <v-container fluid>
    <div v-if="loading">
      <div class="mb-3">
        <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
      </div>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <div class="text-h1 mb-4">
        <v-row>
          <v-col cols="12">
            <div class="text-h2 text-primary mb-0">
              Acompanhamento das Usinas
            </div>
          </v-col>
          <v-col cols="11" class="pt-0">
            <v-row no-gutters>
              <div class="ml-3 ui-mw_autoc">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  v-model="ano"
                  :items="anos"
                  clearable
                  clear-icon="close"
                  label="Ano"
                  hide-details=""
                  append-icon="expand_more"
                  :loading="loadingSearch || loadingAnos"
                  :disabled="loadingSearch || loadingAnos"
                  outlined
                >
                </v-autocomplete>
              </div>
              <div class="ml-3 mw_usina">
                <v-combobox
                  :menu-props="{ offsetY: true}"
                  v-model="usina"
                  :items="usinas"
                  class="full_width"
                  :search-input.sync="searchUsina"
                  hide-selected
                  label="Usinas"
                  multiple
                  hide-details=""
                  clear-icon="close"
                  append-icon="expand_more"
                  @keyup="searchUsinas()"
                  :loading="loadingSearch || loadingUsinas"
                  :disabled="loadingSearch || loadingUsinas"
                  outlined
                  small-chips
                >
                  <template v-slot:selection="{ attrs, item, parent, selected }">
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      v-if="item.text"
                      label
                      small
                    >
                      <span class="pr-2">
                        {{ item.text.split(' - ')[0] }}
                      </span>
                      <v-icon
                        small
                        @click="parent.selectItem(item)"
                      >
                        close
                      </v-icon>
                    </v-chip>
                  </template>
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title v-if="searched">
                          Nenhnum resultado encontrado com "<strong>{{ searchUsina }}</strong>".
                        </v-list-item-title>
                        <v-list-item-title v-else>
                          Buscar por nome da usina
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-combobox>
              </div>
              <div class="ml-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="ui-btn-inherit ui-search_btn" v-bind="attrs" v-on="on" :loading="loadingSearch" :disabled="loadingSearch" @click="applyFilter()">
                      <v-icon>search</v-icon>
                    </v-btn>
                  </template>
                  <span>Filtrar</span>
                </v-tooltip>
              </div>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <div class="text font-italic mb-2 pl-3" v-if="!dados.length">
        Selecione as usinas e o ano em que deseja realizar a consulta.
      </div>
      <v-data-table
        :headers="headers"
        :items="dados"
        :search="search"
        multi-sort
        class="elevation-1 base_table"
        :footer-props="{
          itemsPerPageOptions: [5,10,15,20,25,50,100],
          showFirstLastPage: true,
          firstIcon: 'skip_previous',
          lastIcon: 'skip_next',
          prevIcon: 'chevron_left',
          nextIcon: 'chevron_right'
        }"
        :header-props="{
          sortIcon: 'north',
        }"
        v-if="dados.length"
      >
        <template v-slot:top>
          <v-row no-gutters align="center" justify="space-between">
            <div class="py-2 px-2 table_search_area">
              <v-text-field
                clearable
                hide-details=""
                clear-icon="close"
                v-model="search"
                outlined
                label="Busca"
              ></v-text-field>
            </div>
          </v-row>
        </template>
        <template v-slot:item.usi_nome="{ item }">
          <span class="pl-4">
            <!-- <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openDialog(item)" color="primary" class="mr-2" :disabled="salvando">
                  solar_power
                </v-icon>
              </template>
              <span>Detalhes da Usina</span>
            </v-tooltip> -->
            {{item.usi_nome}}
          </span>
        </template>
        <template v-slot:item.desempenho.desempenho.Jan="{ item }">
          <v-tooltip top >
            <template v-slot:activator="{ on, attrs }" v-if="item.desempenho && item.desempenho.desempenho && item.desempenho.desempenho.Jan">
              <div class="td_table" :class="validaCorDesempenho(item.desempenho.desempenho.Jan, 'bg')" v-bind="attrs" v-on="on">
                {{item.desempenho.desempenho.Jan}}
              </div>
            </template>
            <template v-else v-slot:activator="{ on, attrs }">
              <div class="td_table" v-bind="attrs" v-on="on">
                -
              </div>
            </template>
            <span v-if="item.desempenho && item.desempenho.desempenho && item.desempenho.desempenho.Jan != '-'">
              Energia Produzida: <b>{{item.desempenho.produzido.Jan}} kWh</b><br>
              Energia Projetada: <b>{{item.desempenho.projetado.Jan}} kWh</b><br>
              Objetivo Mínimo: <b>{{item.projeto.usp_objetivo_minimo_jan || '-'}} kWh</b>
              <br><br>
              Desempenho: <b :class="validaCorDesempenho(item.desempenho.desempenho.Jan, 'text')">{{item.desempenho.desempenho.Jan}}%</b>
            </span>
            <span v-else>Sem dados</span>
          </v-tooltip>
        </template>
        <template v-slot:item.desempenho.desempenho.Fev="{ item }">
          <v-tooltip top >
            <template v-slot:activator="{ on, attrs }" v-if="item.desempenho && item.desempenho.desempenho && item.desempenho.desempenho.Fev">
              <div class="td_table" :class="validaCorDesempenho(item.desempenho.desempenho.Fev, 'bg')" v-bind="attrs" v-on="on">
                {{item.desempenho.desempenho.Fev}}
              </div>
            </template>
            <template v-else v-slot:activator="{ on, attrs }">
              <div class="td_table" v-bind="attrs" v-on="on">
                -
              </div>
            </template>
            <span v-if="item.desempenho && item.desempenho.desempenho && item.desempenho.desempenho.Fev != '-'">
              Energia Produzida: <b>{{item.desempenho.produzido.Fev}} kWh</b><br>
              Energia Projetada: <b>{{item.desempenho.projetado.Fev}} kWh</b><br>
              Objetivo Mínimo: <b>{{item.projeto.usp_objetivo_minimo_fev || '-'}} kWh</b>
              <br><br>
              Desempenho: <b :class="validaCorDesempenho(item.desempenho.desempenho.Fev, 'text')">{{item.desempenho.desempenho.Fev}}%</b>
            </span>
            <span v-else>Sem dados</span>
          </v-tooltip>
        </template>
        <template v-slot:item.desempenho.desempenho.Mar="{ item }">
          <v-tooltip top >
            <template v-slot:activator="{ on, attrs }" v-if="item.desempenho && item.desempenho.desempenho && item.desempenho.desempenho.Mar">
              <div class="td_table" :class="validaCorDesempenho(item.desempenho.desempenho.Mar, 'bg')" v-bind="attrs" v-on="on">
                {{item.desempenho.desempenho.Mar}}
              </div>
            </template>
            <template v-else v-slot:activator="{ on, attrs }">
              <div class="td_table" v-bind="attrs" v-on="on">
                -
              </div>
            </template>
            <span v-if="item.desempenho && item.desempenho.desempenho && item.desempenho.desempenho.Mar != '-'">
              Energia Produzida: <b>{{item.desempenho.produzido.Mar}} kWh</b><br>
              Energia Projetada: <b>{{item.desempenho.projetado.Mar}} kWh</b><br>
              Objetivo Mínimo: <b>{{item.projeto.usp_objetivo_minimo_mar || '-'}} kWh</b>
              <br><br>
              Desempenho: <b :class="validaCorDesempenho(item.desempenho.desempenho.Mar, 'text')">{{item.desempenho.desempenho.Mar}}%</b>
            </span>
            <span v-else>Sem dados</span>
          </v-tooltip>
        </template>
        <template v-slot:item.desempenho.desempenho.Abr="{ item }">
          <v-tooltip top >
            <template v-slot:activator="{ on, attrs }" v-if="item.desempenho && item.desempenho.desempenho && item.desempenho.desempenho.Abr">
              <div class="td_table" :class="validaCorDesempenho(item.desempenho.desempenho.Abr, 'bg')" v-bind="attrs" v-on="on">
                {{item.desempenho.desempenho.Abr}}
              </div>
            </template>
            <template v-else v-slot:activator="{ on, attrs }">
              <div class="td_table" v-bind="attrs" v-on="on">
                -
              </div>
            </template>
            <span v-if="item.desempenho && item.desempenho.desempenho && item.desempenho.desempenho.Abr != '-'">
              Energia Produzida: <b>{{item.desempenho.produzido.Abr}} kWh</b><br>
              Energia Projetada: <b>{{item.desempenho.projetado.Abr}} kWh</b><br>
              Objetivo Mínimo: <b>{{item.projeto.usp_objetivo_minimo_abr || '-'}} kWh</b>
              <br><br>
              Desempenho: <b :class="validaCorDesempenho(item.desempenho.desempenho.Abr, 'text')">{{item.desempenho.desempenho.Abr}}%</b>
            </span>
            <span v-else>Sem dados</span>
          </v-tooltip>
        </template>
        <template v-slot:item.desempenho.desempenho.Mai="{ item }">
          <v-tooltip top >
            <template v-slot:activator="{ on, attrs }" v-if="item.desempenho && item.desempenho.desempenho && item.desempenho.desempenho.Mai">
              <div class="td_table" :class="validaCorDesempenho(item.desempenho.desempenho.Mai, 'bg')" v-bind="attrs" v-on="on">
                {{item.desempenho.desempenho.Mai}}
              </div>
            </template>
            <template v-else v-slot:activator="{ on, attrs }">
              <div class="td_table" v-bind="attrs" v-on="on">
                -
              </div>
            </template>
            <span v-if="item.desempenho && item.desempenho.desempenho && item.desempenho.desempenho.Mai != '-'">
              Energia Produzida: <b>{{item.desempenho.produzido.Mai}} kWh</b><br>
              Energia Projetada: <b>{{item.desempenho.projetado.Mai}} kWh</b><br>
              Objetivo Mínimo: <b>{{item.projeto.usp_objetivo_minimo_mai || '-'}} kWh</b>
              <br><br>
              Desempenho: <b :class="validaCorDesempenho(item.desempenho.desempenho.Mai, 'text')">{{item.desempenho.desempenho.Mai}}%</b>
            </span>
            <span v-else>Sem dados</span>
          </v-tooltip>
        </template>
        <template v-slot:item.desempenho.desempenho.Jun="{ item }">
          <v-tooltip top >
            <template v-slot:activator="{ on, attrs }" v-if="item.desempenho && item.desempenho.desempenho && item.desempenho.desempenho.Jun">
              <div class="td_table" :class="validaCorDesempenho(item.desempenho.desempenho.Jun, 'bg')" v-bind="attrs" v-on="on">
                {{item.desempenho.desempenho.Jun}}
              </div>
            </template>
            <template v-else v-slot:activator="{ on, attrs }">
              <div class="td_table" v-bind="attrs" v-on="on">
                -
              </div>
            </template>
            <span v-if="item.desempenho && item.desempenho.desempenho && item.desempenho.desempenho.Jun != '-'">
              Energia Produzida: <b>{{item.desempenho.produzido.Jun}} kWh</b><br>
              Energia Projetada: <b>{{item.desempenho.projetado.Jun}} kWh</b><br>
              Objetivo Mínimo: <b>{{item.projeto.usp_objetivo_minimo_jun || '-'}} kWh</b>
              <br><br>
              Desempenho: <b :class="validaCorDesempenho(item.desempenho.desempenho.Jun, 'text')">{{item.desempenho.desempenho.Jun}}%</b>
            </span>
            <span v-else>Sem dados</span>
          </v-tooltip>
        </template>
        <template v-slot:item.desempenho.desempenho.Jul="{ item }">
          <v-tooltip top >
            <template v-slot:activator="{ on, attrs }" v-if="item.desempenho && item.desempenho.desempenho && item.desempenho.desempenho.Jul">
              <div class="td_table" :class="validaCorDesempenho(item.desempenho.desempenho.Jul, 'bg')" v-bind="attrs" v-on="on">
                {{item.desempenho.desempenho.Jul}}
              </div>
            </template>
            <template v-else v-slot:activator="{ on, attrs }">
              <div class="td_table" v-bind="attrs" v-on="on">
                -
              </div>
            </template>
            <span v-if="item.desempenho && item.desempenho.desempenho && item.desempenho.desempenho.Jul != '-'">
              Energia Produzida: <b>{{item.desempenho.produzido.Jul}} kWh</b><br>
              Energia Projetada: <b>{{item.desempenho.projetado.Jul}} kWh</b><br>
              Objetivo Mínimo: <b>{{item.projeto.usp_objetivo_minimo_jul || '-'}} kWh</b>
              <br><br>
              Desempenho: <b :class="validaCorDesempenho(item.desempenho.desempenho.Jul, 'text')">{{item.desempenho.desempenho.Jul}}%</b>
            </span>
            <span v-else>Sem dados</span>
          </v-tooltip>
        </template>
        <template v-slot:item.desempenho.desempenho.Ago="{ item }">
          <v-tooltip top >
            <template v-slot:activator="{ on, attrs }" v-if="item.desempenho && item.desempenho.desempenho && item.desempenho.desempenho.Ago">
              <div class="td_table" :class="validaCorDesempenho(item.desempenho.desempenho.Ago, 'bg')" v-bind="attrs" v-on="on">
                {{item.desempenho.desempenho.Ago}}
              </div>
            </template>
            <template v-else v-slot:activator="{ on, attrs }">
              <div class="td_table" v-bind="attrs" v-on="on">
                -
              </div>
            </template>
            <span v-if="item.desempenho && item.desempenho.desempenho && item.desempenho.desempenho.Ago != '-'">
              Energia Produzida: <b>{{item.desempenho.produzido.Ago}} kWh</b><br>
              Energia Projetada: <b>{{item.desempenho.projetado.Ago}} kWh</b><br>
              Objetivo Mínimo: <b>{{item.projeto.usp_objetivo_minimo_ago || '-'}} kWh</b>
              <br><br>
              Desempenho: <b :class="validaCorDesempenho(item.desempenho.desempenho.Ago, 'text')">{{item.desempenho.desempenho.Ago}}%</b>
            </span>
            <span v-else>Sem dados</span>
          </v-tooltip>
        </template>
        <template v-slot:item.desempenho.desempenho.Set="{ item }">
          <v-tooltip top >
            <template v-slot:activator="{ on, attrs }" v-if="item.desempenho && item.desempenho.desempenho && item.desempenho.desempenho.Set">
              <div class="td_table" :class="validaCorDesempenho(item.desempenho.desempenho.Set, 'bg')" v-bind="attrs" v-on="on">
                {{item.desempenho.desempenho.Set}}
              </div>
            </template>
            <template v-else v-slot:activator="{ on, attrs }">
              <div class="td_table" v-bind="attrs" v-on="on">
                -
              </div>
            </template>
            <span v-if="item.desempenho && item.desempenho.desempenho && item.desempenho.desempenho.Set != '-'">
              Energia Produzida: <b>{{item.desempenho.produzido.Set}} kWh</b><br>
              Energia Projetada: <b>{{item.desempenho.projetado.Set}} kWh</b><br>
              Objetivo Mínimo: <b>{{item.projeto.usp_objetivo_minimo_set || '-'}} kWh</b>
              <br><br>
              Desempenho: <b :class="validaCorDesempenho(item.desempenho.desempenho.Set, 'text')">{{item.desempenho.desempenho.Set}}%</b>
            </span>
            <span v-else>Sem dados</span>
          </v-tooltip>
        </template>
        <template v-slot:item.desempenho.desempenho.Out="{ item }">
          <v-tooltip top >
            <template v-slot:activator="{ on, attrs }" v-if="item.desempenho && item.desempenho.desempenho && item.desempenho.desempenho.Out">
              <div class="td_table" :class="validaCorDesempenho(item.desempenho.desempenho.Out, 'bg')" v-bind="attrs" v-on="on">
                {{item.desempenho.desempenho.Out}}
              </div>
            </template>
            <template v-else v-slot:activator="{ on, attrs }">
              <div class="td_table" v-bind="attrs" v-on="on">
                -
              </div>
            </template>
            <span v-if="item.desempenho && item.desempenho.desempenho && item.desempenho.desempenho.Out != '-'">
              Energia Produzida: <b>{{item.desempenho.produzido.Out}} kWh</b><br>
              Energia Projetada: <b>{{item.desempenho.projetado.Out}} kWh</b><br>
              Objetivo Mínimo: <b>{{item.projeto.usp_objetivo_minimo_out || '-'}} kWh</b>
              <br><br>
              Desempenho: <b :class="validaCorDesempenho(item.desempenho.desempenho.Out, 'text')">{{item.desempenho.desempenho.Out}}%</b>
            </span>
            <span v-else>Sem dados</span>
          </v-tooltip>
        </template>
        <template v-slot:item.desempenho.desempenho.Nov="{ item }">
          <v-tooltip top >
            <template v-slot:activator="{ on, attrs }" v-if="item.desempenho && item.desempenho.desempenho && item.desempenho.desempenho.Nov">
              <div class="td_table" :class="validaCorDesempenho(item.desempenho.desempenho.Nov, 'bg')" v-bind="attrs" v-on="on">
                {{item.desempenho.desempenho.Nov}}
              </div>
            </template>
            <template v-else v-slot:activator="{ on, attrs }">
              <div class="td_table" v-bind="attrs" v-on="on">
                -
              </div>
            </template>
            <span v-if="item.desempenho && item.desempenho.desempenho && item.desempenho.desempenho.Nov != '-'">
              Energia Produzida: <b>{{item.desempenho.produzido.Nov}} kWh</b><br>
              Energia Projetada: <b>{{item.desempenho.projetado.Nov}} kWh</b><br>
              Objetivo Mínimo: <b>{{item.projeto.usp_objetivo_minimo_nov || '-'}} kWh</b>
              <br><br>
              Desempenho: <b :class="validaCorDesempenho(item.desempenho.desempenho.Nov, 'text')">{{item.desempenho.desempenho.Nov}}%</b>
            </span>
            <span v-else>Sem dados</span>
          </v-tooltip>
        </template>
        <template v-slot:item.desempenho.desempenho.Dez="{ item }">
          <v-tooltip top >
            <template v-slot:activator="{ on, attrs }" v-if="item.desempenho && item.desempenho.desempenho && item.desempenho.desempenho.Dez">
              <div class="td_table" :class="validaCorDesempenho(item.desempenho.desempenho.Dez, 'bg')" v-bind="attrs" v-on="on">
                {{item.desempenho.desempenho.Dez}}
              </div>
            </template>
            <template v-else v-slot:activator="{ on, attrs }">
              <div class="td_table" v-bind="attrs" v-on="on">
                -
              </div>
            </template>
            <span v-if="item.desempenho && item.desempenho.desempenho && item.desempenho.desempenho.Dez != '-'">
              Energia Produzida: <b>{{item.desempenho.produzido.Dez}} kWh</b><br>
              Energia Projetada: <b>{{item.desempenho.projetado.Dez}} kWh</b><br>
              Objetivo Mínimo: <b>{{item.projeto.usp_objetivo_minimo_dez || '-'}} kWh</b>
              <br><br>
              Desempenho: <b :class="validaCorDesempenho(item.desempenho.desempenho.Dez, 'text')">{{item.desempenho.desempenho.Dez}}%</b>
            </span>
            <span v-else>Sem dados</span>
          </v-tooltip>
        </template>
        <template v-slot:item.desempenho.ano.desempenho="{ item }">
          <v-tooltip top >
            <template v-slot:activator="{ on, attrs }" v-if="item.desempenho && item.desempenho.ano && item.desempenho.ano.desempenho">
              <div class="td_table" :class="validaCorDesempenho(item.desempenho.ano.desempenho, 'bg')" v-bind="attrs" v-on="on">
                {{item.desempenho.ano.desempenho}}
              </div>
            </template>
            <template v-else v-slot:activator="{ on, attrs }">
              <div class="td_table" v-bind="attrs" v-on="on">
                -
              </div>
            </template>
            <span v-if="item.desempenho && item.desempenho.ano && item.desempenho.ano.desempenho != '-'">
              Energia Produzida: <b>{{item.desempenho.ano.produzido}} kWh</b><br>
              Energia Projetada: <b>{{item.desempenho.ano.projetado}} kWh</b><br>
              Objetivo Mínimo: <b>{{geracaoAnualObjetivoMinimo(item)}} kWh</b>
              <br><br>
              Desempenho: <b :class="validaCorDesempenho(item.desempenho.ano.desempenho, 'text')">{{item.desempenho.ano.desempenho}}%</b>
            </span>
            <span v-else>Sem dados</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <div class="mt-3" v-if="dados.length">
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6" xl="6" v-if="chartData">
            <div class="text-primary text-h2 mb-2">
              Portfólio por meses do ano
            </div>
            <v-card class="px-2 py-2" elevation="2">
              <bar-chart :options="optionsChart" :height="250" :data="chartData"></bar-chart>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6" xl="6" v-if="chartDataAnual">
            <div class="text-primary text-h2 mb-2">
              Evolução do desempenho anual
            </div>
            <v-card class="px-2 py-2" elevation="2">
              <bar-chart :options="optionsChart" :height="250" :data="chartDataAnual"></bar-chart>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <!-- área dialog usina -->
      <v-dialog
        v-model="dialogUsina"
        persistent
        max-width="1050px"
      >
        <v-card class="ui-dialog-top">
          <v-row align="center" justify="space-between">
            <v-col cols="10">
              {{usina ? usina.usi_nome : ''}}
            </v-col>
            <v-col cols="2" class="text-right">
              <v-icon @click="closeDialogDetalhesUsina()">close</v-icon>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="ui-dialog-content">
          <v-form ref="formUsinaDetalhes">
            <v-row>
              <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0">
                <v-text-field
                  v-model="usina_detalhes.usp_potencia"
                  autofocus
                  :rules="[rules.required]"
                  label="Potência (kWp)*"
                  outlined
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0">
                <v-text-field
                  v-model="usina_detalhes.usp_eficiencia"
                  :rules="[rules.required]"
                  label="Eficiência*"
                  outlined
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0">
                <v-menu
                  ref="calendarDataInstalacao"
                  v-model="calendarDataInstalacao"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      label="Data da instalação"
                      append-icon="calendar_today"
                      :loading="salvando"
                      :disabled="salvando"
                      v-bind="attrs"
                      v-on="on"
                      v-model="dataFormatadaInstalacao"
                      v-mask="'##/##/####'"
                      @input="() => {
                        calendarDataInstalacao = false
                        usina_detalhes.usp_data_instalacao = $root.Formatter.parseDate(dataFormatadaInstalacao)
                        updatePickerModalDataInstalacao = $root.Formatter.parseDate(dataFormatadaInstalacao)
                      }"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    :picker-date.sync="updatePickerModalDataInstalacao"
                    year-icon="calendar_today"
                    prev-icon="chevron_left"
                    next-icon="chevron_right"
                    :loading="salvando"
                    :disabled="salvando"
                    v-model="dataInstalacao"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pt-0 pb-0">
                <vuetify-money
                  lazy-validation
                  v-model="usina_detalhes.usp_total_investido"
                  :backgroundColor="$vuetify.theme.dark ? '#1e1e1e00' : '#fff'"
                  :disabled="salvando"
                  :loading="salvando"
                  outlined
                  :options="options"
                  valueWhenIsEmpty="0,00"
                  label="Total investido"
                ></vuetify-money>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pt-0 pb-0">
                <v-text-field
                  v-model="usina_detalhes.usp_tarifa_referencia"
                  label="Tarifa de referência"
                  outlined
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pt-0 pb-0">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  v-model="usina_detalhes.uuid_uss_id"
                  :items="status"
                  clearable
                  clear-icon="close"
                  :rules="[rules.required]"
                  label="Status*"
                  append-icon="expand_more"
                  :loading="salvando || loadingStatus"
                  :disabled="salvando || loadingStatus"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
                <v-text-field
                  :value="usina && usina_detalhes.usp_rsi_jan ? rendimentoAnual() : 0"
                  label="Rendimento anual (h)"
                  outlined
                  :disabled="true"
                  :loading="salvando"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
                <v-text-field
                  :value="usina && usina_detalhes.usp_rsi_jan ? geracaoAnualPrevista() : 0"
                  label="Geração anual prevista (kWh)"
                  outlined
                  :disabled="true"
                  :loading="salvando"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
                <v-row align="center">
                  <v-col cols="12" sm="2" md="2" lg="2" xl="2">
                    <v-btn
                      color="primary"
                      :loading="salvando"
                      :disabled="salvando"
                      class="consulta"
                      @click="getDadosRSI()"
                    >
                      Consultar RSI
                    </v-btn>
                  </v-col>
                  <v-col cols="12" sm="4" md="4" lg="4" xl="4" v-if="selectRSI.length > 0">
                    <v-autocomplete
                      :menu-props="{ offsetY: true}"
                      :items="selectRSI"
                      clearable
                      clear-icon="close"
                      hide-details=""
                      :rules="[rules.required]"
                      v-model="usina_detalhes.rsiSelect"
                      label="Estação*"
                      @change="selecionaEstacaoRSI()"
                      append-icon="expand_more"
                      :loading="salvando"
                      :disabled="salvando"
                      outlined
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-col>
              <!-- <v-col cols="12" sm="3" md="3" lg="3" xl="3" v-if="usina_detalhes.angulo">
                <v-text-field
                  v-model="usina_detalhes.angulo"
                  label="Ângulo"
                  outlined
                  hide-details=""
                  :disabled="true"
                  :loading="salvando"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2" md="2" lg="2" xl="2" v-if="usina_detalhes.distancia">
                <v-text-field
                  v-model="usina_detalhes.distancia"
                  label="Distância"
                  outlined
                  hide-details=""
                  :disabled="true"
                  :loading="salvando"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3" lg="3" xl="3" v-if="usina_detalhes.estacao">
                <v-text-field
                  v-model="usina_detalhes.estacao"
                  label="Estação"
                  outlined
                  hide-details=""
                  :disabled="true"
                  :loading="salvando"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2" md="2" lg="2" xl="2" v-if="usina_detalhes.inclinicao">
                <v-text-field
                  v-model="usina_detalhes.inclinicao"
                  label="Inclinação"
                  outlined
                  hide-details=""
                  :disabled="true"
                  :loading="salvando"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2" md="2" lg="2" xl="2" v-if="usina_detalhes.municipio">
                <v-text-field
                  v-model="usina_detalhes.municipio"
                  label="Município"
                  outlined
                  hide-details=""
                  :disabled="true"
                  :loading="salvando"
                ></v-text-field>
              </v-col> -->
              <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 pb-0"></v-col>
              <v-col cols="12" sm="2" md="2" lg="2" xl="2">
                <v-text-field
                  v-model="usina_detalhes.usp_rsi_jan"
                  label="RSI Janeiro*"
                  outlined
                  hide-details=""
                  suffix="h"
                  :rules="[rules.required]"
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
                <v-text-field
                  class="mt-2"
                  v-model="usina_detalhes.usp_objetivo_minimo_jan"
                  label="Objetivo Mínimo"
                  outlined
                  hide-details=""
                  suffix="kWh"
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
                <div class="value_area">
                  {{returnvalorRSIMes(usina_detalhes.usp_rsi_jan, 1)}} kWh
                </div>
                <div class="value_area_porcentagem">
                  {{returnvalorRSIPorcentagem(usina_detalhes.usp_rsi_jan, 1)}}
                </div>
              </v-col>
              <v-col cols="12" sm="2" md="2" lg="2" xl="2">
                <v-text-field
                  v-model="usina_detalhes.usp_rsi_fev"
                  label="RSI Fevereiro*"
                  outlined
                  hide-details=""
                  suffix="h"
                  :rules="[rules.required]"
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
                <v-text-field
                  class="mt-2"
                  v-model="usina_detalhes.usp_objetivo_minimo_fev"
                  label="Objetivo Mínimo"
                  outlined
                  hide-details=""
                  suffix="kWh"
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
                <div class="value_area">
                  {{returnvalorRSIMes(usina_detalhes.usp_rsi_fev, 2)}} kWh
                </div>
                <div class="value_area_porcentagem">
                  {{returnvalorRSIPorcentagem(usina_detalhes.usp_rsi_fev, 2)}}
                </div>
              </v-col>
              <v-col cols="12" sm="2" md="2" lg="2" xl="2">
                <v-text-field
                  v-model="usina_detalhes.usp_rsi_mar"
                  label="RSI Março*"
                  outlined
                  hide-details=""
                  suffix="h"
                  :rules="[rules.required]"
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
                <v-text-field
                  class="mt-2"
                  v-model="usina_detalhes.usp_objetivo_minimo_mar"
                  label="Objetivo Mínimo"
                  outlined
                  hide-details=""
                  suffix="kWh"
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
                <div class="value_area">
                  {{returnvalorRSIMes(usina_detalhes.usp_rsi_mar, 3)}} kWh
                </div>
                <div class="value_area_porcentagem">
                  {{returnvalorRSIPorcentagem(usina_detalhes.usp_rsi_mar, 3)}}
                </div>
              </v-col>
              <v-col cols="12" sm="2" md="2" lg="2" xl="2">
                <v-text-field
                  v-model="usina_detalhes.usp_rsi_abr"
                  label="RSI Abril*"
                  outlined
                  hide-details=""
                  suffix="h"
                  :rules="[rules.required]"
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
                <v-text-field
                  class="mt-2"
                  v-model="usina_detalhes.usp_objetivo_minimo_abr"
                  label="Objetivo Mínimo"
                  outlined
                  hide-details=""
                  suffix="kWh"
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
                <div class="value_area">
                  {{returnvalorRSIMes(usina_detalhes.usp_rsi_abr, 4)}} kWh
                </div>
                <div class="value_area_porcentagem">
                  {{returnvalorRSIPorcentagem(usina_detalhes.usp_rsi_abr, 4)}}
                </div>
              </v-col>
              <v-col cols="12" sm="2" md="2" lg="2" xl="2">
                <v-text-field
                  v-model="usina_detalhes.usp_rsi_mai"
                  label="RSI Maio*"
                  outlined
                  hide-details=""
                  suffix="h"
                  :rules="[rules.required]"
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
                <v-text-field
                  class="mt-2"
                  v-model="usina_detalhes.usp_objetivo_minimo_mai"
                  label="Objetivo Mínimo"
                  outlined
                  hide-details=""
                  suffix="kWh"
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
                <div class="value_area">
                  {{returnvalorRSIMes(usina_detalhes.usp_rsi_mai, 5)}} kWh
                </div>
                <div class="value_area_porcentagem">
                  {{returnvalorRSIPorcentagem(usina_detalhes.usp_rsi_mai, 5)}}
                </div>
              </v-col>
              <v-col cols="12" sm="2" md="2" lg="2" xl="2">
                <v-text-field
                  v-model="usina_detalhes.usp_rsi_jun"
                  label="RSI Junho*"
                  outlined
                  hide-details=""
                  suffix="h"
                  :rules="[rules.required]"
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
                <v-text-field
                  class="mt-2"
                  v-model="usina_detalhes.usp_objetivo_minimo_jun"
                  label="Objetivo Mínimo"
                  outlined
                  hide-details=""
                  suffix="kWh"
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
                <div class="value_area">
                  {{returnvalorRSIMes(usina_detalhes.usp_rsi_jun, 6)}} kWh
                </div>
                <div class="value_area_porcentagem">
                  {{returnvalorRSIPorcentagem(usina_detalhes.usp_rsi_jun, 6)}}
                </div>
              </v-col>
              <v-col cols="12" sm="2" md="2" lg="2" xl="2">
                <v-text-field
                  v-model="usina_detalhes.usp_rsi_jul"
                  label="RSI Julho*"
                  outlined
                  hide-details=""
                  suffix="h"
                  :rules="[rules.required]"
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
                <v-text-field
                  class="mt-2"
                  v-model="usina_detalhes.usp_objetivo_minimo_jul"
                  label="Objetivo Mínimo"
                  outlined
                  hide-details=""
                  suffix="kWh"
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
                <div class="value_area">
                  {{returnvalorRSIMes(usina_detalhes.usp_rsi_jul, 7)}} kWh
                </div>
                <div class="value_area_porcentagem">
                  {{returnvalorRSIPorcentagem(usina_detalhes.usp_rsi_jul, 7)}}
                </div>
              </v-col>
              <v-col cols="12" sm="2" md="2" lg="2" xl="2">
                <v-text-field
                  v-model="usina_detalhes.usp_rsi_ago"
                  label="RSI Agosto*"
                  outlined
                  hide-details=""
                  suffix="h"
                  :rules="[rules.required]"
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
                <v-text-field
                  class="mt-2"
                  v-model="usina_detalhes.usp_objetivo_minimo_ago"
                  label="Objetivo Mínimo"
                  outlined
                  hide-details=""
                  suffix="kWh"
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
                <div class="value_area">
                  {{returnvalorRSIMes(usina_detalhes.usp_rsi_ago, 8)}} kWh
                </div>
                <div class="value_area_porcentagem">
                  {{returnvalorRSIPorcentagem(usina_detalhes.usp_rsi_ago, 8)}}
                </div>
              </v-col>
              <v-col cols="12" sm="2" md="2" lg="2" xl="2">
                <v-text-field
                  v-model="usina_detalhes.usp_rsi_set"
                  label="RSI Setembro*"
                  outlined
                  hide-details=""
                  suffix="h"
                  :rules="[rules.required]"
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
                <v-text-field
                  class="mt-2"
                  v-model="usina_detalhes.usp_objetivo_minimo_set"
                  label="Objetivo Mínimo"
                  outlined
                  hide-details=""
                  suffix="kWh"
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
                <div class="value_area">
                  {{returnvalorRSIMes(usina_detalhes.usp_rsi_set, 9)}} kWh
                </div>
                <div class="value_area_porcentagem">
                  {{returnvalorRSIPorcentagem(usina_detalhes.usp_rsi_set, 9)}}
                </div>
              </v-col>
              <v-col cols="12" sm="2" md="2" lg="2" xl="2">
                <v-text-field
                  v-model="usina_detalhes.usp_rsi_out"
                  label="RSI Outubro*"
                  outlined
                  hide-details=""
                  suffix="h"
                  :rules="[rules.required]"
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
                <v-text-field
                  class="mt-2"
                  v-model="usina_detalhes.usp_objetivo_minimo_out"
                  label="Objetivo Mínimo"
                  outlined
                  hide-details=""
                  suffix="kWh"
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
                <div class="value_area">
                  {{returnvalorRSIMes(usina_detalhes.usp_rsi_out, 10)}} kWh
                </div>
                <div class="value_area_porcentagem">
                  {{returnvalorRSIPorcentagem(usina_detalhes.usp_rsi_out, 10)}}
                </div>
              </v-col>
              <v-col cols="12" sm="2" md="2" lg="2" xl="2">
                <v-text-field
                  v-model="usina_detalhes.usp_rsi_nov"
                  label="RSI Novembro*"
                  outlined
                  hide-details=""
                  suffix="h"
                  :rules="[rules.required]"
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
                <v-text-field
                  class="mt-2"
                  v-model="usina_detalhes.usp_objetivo_minimo_nov"
                  label="Objetivo Mínimo"
                  outlined
                  hide-details=""
                  suffix="kWh"
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
                <div class="value_area">
                  {{returnvalorRSIMes(usina_detalhes.usp_rsi_nov, 11)}} kWh
                </div>
                <div class="value_area_porcentagem">
                  {{returnvalorRSIPorcentagem(usina_detalhes.usp_rsi_nov, 11)}}
                </div>
              </v-col>
              <v-col cols="12" sm="2" md="2" lg="2" xl="2">
                <v-text-field
                  v-model="usina_detalhes.usp_rsi_dez"
                  label="RSI Dezembro*"
                  outlined
                  hide-details=""
                  suffix="h"
                  :rules="[rules.required]"
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
                <v-text-field
                  class="mt-2"
                  v-model="usina_detalhes.usp_objetivo_minimo_dez"
                  label="Objetivo Mínimo"
                  outlined
                  hide-details=""
                  suffix="kWh"
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
                <div class="value_area">
                  {{returnvalorRSIMes(usina_detalhes.usp_rsi_dez, 12)}} kWh
                </div>
                <div class="value_area_porcentagem">
                  {{returnvalorRSIPorcentagem(usina_detalhes.usp_rsi_dez, 12)}}
                </div>
              </v-col>
            </v-row>
          </v-form>
          <v-divider class="mt-4"></v-divider>
          <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
            <v-btn
              color="cancel"
              :disabled="salvando"
              :loading="salvando"
              @click="closeDialogDetalhesUsina()"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              @click="editDetalhesUsina()"
              :loading="salvando"
              :disabled="salvando"
            >
              Editar
            </v-btn>
          </v-row>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import Api from '@API'
import moment from 'moment'
import _debounce from 'lodash.debounce'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import LineChart from '@components/graficos/LineChart.vue'
import BarChart from '@components/graficos/BarChart.vue'
export default {
  components: {
    VueCtkDateTimePicker,
    LineChart,
    BarChart
  },
  data () {
    return {
      loading: true,
      loadingSearch: false,
      loadingAnos: false,
      anos: [],
      ano: '',
      usinas: [],
      loadingUsinas: false,
      usina: '',
      dialogUsina: false,
      usinaDialog: '',
      search: '',
      salvando: false,
      searchUsina: '',
      searched: false,
      rules: {
        required: value => !!value || 'Obrigatório.'
      },
      loadingStatus: false,
      status: [],
      usina_detalhes: {
        usp_potencia: '',
        usp_eficiencia: '',
        usp_data_instalacao: '',
        usp_total_investido: '',
        usp_tarifa_referencia: '',
        rsiSelect: '',
        usp_rsi_jan: '',
        usp_rsi_fev: '',
        usp_rsi_mar: '',
        usp_rsi_abr: '',
        usp_rsi_mai: '',
        usp_rsi_jun: '',
        usp_rsi_jul: '',
        usp_rsi_ago: '',
        usp_rsi_set: '',
        usp_rsi_out: '',
        usp_rsi_nov: '',
        usp_rsi_dez: '',
        uuid_uss_id: ''
      },
      options: {
        locale: 'pt-BR',
        prefix: 'R$',
        suffix: '',
        length: 10,
        precision: 2
      },
      dataInstalacao: '',
      dataFormatadaInstalacao: '',
      updatePickerModalDataInstalacao: '',
      calendarDataInstalacao: false,
      selectRSI: [],
      selectRSITotal: [],
      geracaoPrevista: '',
      headers: [
        {
          text: 'ID',
          align: 'center',
          value: 'usi_id',
          width: 50
        },
        { text: 'Unidade', value: 'usi_nome' },
        { text: 'kWp', value: 'projeto.usp_potencia', align: 'center' },
        { text: 'JAN', value: 'desempenho.desempenho.Jan', align: 'center' },
        { text: 'FEV', value: 'desempenho.desempenho.Fev', align: 'center' },
        { text: 'MAR', value: 'desempenho.desempenho.Mar', align: 'center' },
        { text: 'ABR', value: 'desempenho.desempenho.Abr', align: 'center' },
        { text: 'MAI', value: 'desempenho.desempenho.Mai', align: 'center' },
        { text: 'JUN', value: 'desempenho.desempenho.Jun', align: 'center' },
        { text: 'JUL', value: 'desempenho.desempenho.Jul', align: 'center' },
        { text: 'AGO', value: 'desempenho.desempenho.Ago', align: 'center' },
        { text: 'SET', value: 'desempenho.desempenho.Set', align: 'center' },
        { text: 'OUT', value: 'desempenho.desempenho.Out', align: 'center' },
        { text: 'NOV', value: 'desempenho.desempenho.Nov', align: 'center' },
        { text: 'DEZ', value: 'desempenho.desempenho.Dez', align: 'center' },
        { text: 'ANO', value: 'desempenho.ano.desempenho', align: 'center' }
      ],
      usinaSearch: '',
      dados: [],
      optionsChart: {
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: function (tooltipItem, data) {
              return tooltipItem.value.replace('.', ',') + '%'
            }
          }
        },
        responsive: true,
        scales: {
          yAxes: [{
            ticks: {
              callback: function (value, index, values) {
                return value + '%'
              }
            }
          }]
        },
        plugins: {
          legend: {
            position: 'top'
          }
        }
      },
      chartData: null,
      chartDataAnual: null
    }
  },
  watch: {
    dataInstalacao () {
      this.dataFormatadaInstalacao = moment(this.dataInstalacao).format('L')
      this.usina_detalhes.usp_data_instalacao = this.$root.Formatter.parseDate(this.dataFormatadaInstalacao)
      this.calendarDataInstalacao = false
    }
  },
  methods: {
    formatDateFront (date, format = 'L') {
      return moment(date).format(format)
    },
    applyFilter () {
      this.loading = true
      if (this.usina.length > 0) {
        let usis = ''
        this.usina.map(mod => {
          if (mod.value) {
            usis += '&usina[]=' + mod.value
          }
        })
        this.usinaSearch = usis
      }
      let query = Object.assign({},
        this.ano ? { ano: this.ano } : '',
        this.usina ? { usina: JSON.stringify(this.usina) } : '',
        this.usinaSearch ? { usinaSearch: this.usinaSearch } : ''
      )
      this.$router.replace({name: 'AcompanhamentoUsinas', query: query}).catch(() => {})
      this.loadFunctions(this.ano, this.usinaSearch)
    },
    loadFunctions (an, usi) {
      let endpoint = an ? '?ano=' + an : '?ano='
      endpoint += usi || '&usina='
      if (usi) {
        this.getDados(endpoint)
      } else {
        this.loading = false
      }
    },
    loadContent () {
      this.getAnos()
      this.getStatus()
      let filters = this.$route.query
      if (filters.ano) this.ano = Number(filters.ano)
      if (filters.usinaSearch) this.usinaSearch = filters.usinaSearch
      if (filters.usina) this.usina = JSON.parse(filters.usina)
      this.loadFunctions(this.ano, filters.usinaSearch)
    },
    async getStatus () {
      this.loadingStatus = true
      await Api.get('usinas-status')
        .then(res => {
          var arrayStat = []
          res.data.map(sta => {
            arrayStat.push({
              'text': sta.uss_nome,
              'value': sta.uuid_uss_id
            })
          })
          this.status = arrayStat
          this.loadingStatus = false
        })
        .catch(err => {
          this.loadingStatus = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os status!',
            color: 'error'
          })
        })
    },
    async getDados (endpoint) {
      this.loading = true
      this.dados = []
      this.chartData = null
      this.chartDataAnual = null

      await Api.get('relatorios/acompanhamento-usinas' + endpoint)
        .then(res => {
          this.dados = res.data
          this.loading = false

          console.log(this.dados)

          if (this.dados.length > 0) {
            this.chartData = {
              labels: ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'],
              datasets: []
            }
            this.chartDataAnual = {
              labels: [],
              datasets: []
            }
            this.dados.forEach(usina => {
              let color = this.generateColor()
              this.chartData.datasets.push({
                label: usina.usi_nome,
                backgroundColor: color,
                lineTension: '0.1',
                data: usina.grafico.data
              })
              if (usina.grafico_anual) {
                this.chartDataAnual.labels = usina.grafico_anual.labels
                this.chartDataAnual.datasets.push({
                  label: usina.usi_nome,
                  backgroundColor: color,
                  lineTension: '0.1',
                  data: usina.grafico_anual.data
                })
              }
            })
          }
        })
        .catch(err => {
          this.dados = []
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao buscar o relatório de acompanhamento de usinas!',
            color: 'error'
          })
          console.log(err)
        })
      // await Api.get('relatorios/faturas' + endpoint)
      //   .then(res => {
      //     this.dados = res.data
      //     console.log('Relatórios de Faturas ==>', res.data)
      //     this.loading = false
      //   })
      //   .catch(err => {
      //     this.loading = false
      //     this.$root.SnackControl.open(this, {
      //       text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os relatórios de faturas!',
      //       color: 'error'
      //     })
      //     console.log(err)
      //   })
    },
    async getAnos () {
      const year = new Date().getFullYear()
      this.loadingAnos = true
      let retorno = await Array.from({length: year - 2015}, (item, index) => 2015 + index + 1)
      this.loadingAnos = false
      this.ano = year
      this.anos = retorno.reverse()
    },
    searchUsinas: _debounce(function () {
      if (this.searchUsina.length < 3) return
      this.getUsinas()
    }, 500),
    async getUsinas () {
      this.loadingUsinas = true
      let endpoint = 'usinas'
      if (this.searchUsina) {
        endpoint += `?busca=${this.searchUsina}`
      }
      await Api.get(endpoint)
        .then(res => {
          var arrayUsi = []
          res.data.map(usi => {
            let text = usi.usi_nome
            if (usi.cliente) {
              text += ` - ${usi.cliente.cli_nome}`
            }
            arrayUsi.push({
              'text': text,
              'value': usi.uuid_usi_id
            })
          })
          this.searched = true
          this.usinas = arrayUsi
          this.loadingUsinas = false
        })
        .catch(err => {
          this.loadingUsinas = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os usinas!',
            color: 'error'
          })
          console.log(err)
        })
    },
    openDialog (item) {
      this.usina = JSON.parse(JSON.stringify(item))
      this.salvando = true
      this.dialogUsina = true
      Api.get('usinas/' + item.uuid_usi_id + '/projeto')
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }

          response.data = {
            ...response.data,
            usp_objetivo_minimo_jan: response.data.usp_objetivo_minimo_jan || this.returnvalorRSIMes(response.data.usp_rsi_jan, 1, response.data.usp_potencia, response.data.usp_eficiencia),
            usp_objetivo_minimo_fev: response.data.usp_objetivo_minimo_fev || this.returnvalorRSIMes(response.data.usp_rsi_fev, 2, response.data.usp_potencia, response.data.usp_eficiencia),
            usp_objetivo_minimo_mar: response.data.usp_objetivo_minimo_mar || this.returnvalorRSIMes(response.data.usp_rsi_mar, 3, response.data.usp_potencia, response.data.usp_eficiencia),
            usp_objetivo_minimo_abr: response.data.usp_objetivo_minimo_abr || this.returnvalorRSIMes(response.data.usp_rsi_abr, 4, response.data.usp_potencia, response.data.usp_eficiencia),
            usp_objetivo_minimo_mai: response.data.usp_objetivo_minimo_mai || this.returnvalorRSIMes(response.data.usp_rsi_mai, 5, response.data.usp_potencia, response.data.usp_eficiencia),
            usp_objetivo_minimo_jun: response.data.usp_objetivo_minimo_jun || this.returnvalorRSIMes(response.data.usp_rsi_jun, 6, response.data.usp_potencia, response.data.usp_eficiencia),
            usp_objetivo_minimo_jul: response.data.usp_objetivo_minimo_jul || this.returnvalorRSIMes(response.data.usp_rsi_jul, 7, response.data.usp_potencia, response.data.usp_eficiencia),
            usp_objetivo_minimo_ago: response.data.usp_objetivo_minimo_ago || this.returnvalorRSIMes(response.data.usp_rsi_ago, 8, response.data.usp_potencia, response.data.usp_eficiencia),
            usp_objetivo_minimo_set: response.data.usp_objetivo_minimo_set || this.returnvalorRSIMes(response.data.usp_rsi_set, 9, response.data.usp_potencia, response.data.usp_eficiencia),
            usp_objetivo_minimo_out: response.data.usp_objetivo_minimo_out || this.returnvalorRSIMes(response.data.usp_rsi_out, 10, response.data.usp_potencia, response.data.usp_eficiencia),
            usp_objetivo_minimo_nov: response.data.usp_objetivo_minimo_nov || this.returnvalorRSIMes(response.data.usp_rsi_nov, 11, response.data.usp_potencia, response.data.usp_eficiencia),
            usp_objetivo_minimo_dez: response.data.usp_objetivo_minimo_dez || this.returnvalorRSIMes(response.data.usp_rsi_dez, 12, response.data.usp_potencia, response.data.usp_eficiencia)
          }

          this.usina_detalhes = JSON.parse(JSON.stringify(response.data))

          if (response.data.usp_data_instalacao) {
            this.dataInstalacao = response.data.usp_data_instalacao
            this.dataFormatadaInstalacao = moment(this.dataInstalacao).format('L')
            this.updatePickerModalDataInstalacao = this.$root.Formatter.parseDate(this.dataFormatadaInstalacao)
          }
          if (response.data.usina && response.data.usina.status) {
            this.usina_detalhes.uuid_uss_id = response.data.usina.status.uuid_uss_id
          }
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados da usina!',
            color: 'error'
          })
        })
    },
    getDadosRSI () {
      this.salvando = true
      this.selectRSI = []
      this.selectRSITotal = []
      this.usina_detalhes.angulo = ''
      this.usina_detalhes.distancia = ''
      this.usina_detalhes.estacao = ''
      this.usina_detalhes.inclinicao = ''
      this.usina_detalhes.municipio = ''
      this.usina_detalhes.rsiSelect = ''
      Api.get('usinas/' + this.usina.uuid_usi_id + '/rsi')
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          var arrayItens = []
          if (response.data.sugestoes.length) {
            response.data.sugestoes.map((ret, ind) => {
              arrayItens.push({
                'text': ret.estacao + ' - ' + ret.distancia,
                'value': ind
              })
            })
            this.selectRSI = arrayItens
            this.selectRSITotal = response.data.sugestoes
          }
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados de RSI!',
            color: 'error'
          })
        })
    },
    selecionaEstacaoRSI () {
      this.salvando = true
      let selecionado = this.selectRSITotal[this.usina_detalhes.rsiSelect]
      this.usina_detalhes.angulo = selecionado.angulo
      this.usina_detalhes.distancia = selecionado.distancia
      this.usina_detalhes.estacao = selecionado.estacao
      this.usina_detalhes.inclinicao = selecionado.inclinicao
      this.usina_detalhes.municipio = selecionado.municipio
      this.usina_detalhes.usp_rsi_jan = selecionado.rsi[0]
      this.usina_detalhes.usp_rsi_fev = selecionado.rsi[1]
      this.usina_detalhes.usp_rsi_mar = selecionado.rsi[2]
      this.usina_detalhes.usp_rsi_abr = selecionado.rsi[3]
      this.usina_detalhes.usp_rsi_mai = selecionado.rsi[4]
      this.usina_detalhes.usp_rsi_jun = selecionado.rsi[5]
      this.usina_detalhes.usp_rsi_jul = selecionado.rsi[6]
      this.usina_detalhes.usp_rsi_ago = selecionado.rsi[7]
      this.usina_detalhes.usp_rsi_set = selecionado.rsi[8]
      this.usina_detalhes.usp_rsi_out = selecionado.rsi[9]
      this.usina_detalhes.usp_rsi_nov = selecionado.rsi[10]
      this.usina_detalhes.usp_rsi_dez = selecionado.rsi[11]
      setTimeout(() => {
        this.salvando = false
      }, 500)
    },
    rendimentoAnual () {
      let jan = parseFloat(moment(1, 'MM').daysInMonth()) * parseFloat(this.usina_detalhes.usp_rsi_jan)
      let fev = parseFloat(moment(2, 'MM').daysInMonth()) * parseFloat(this.usina_detalhes.usp_rsi_fev)
      let mar = parseFloat(moment(3, 'MM').daysInMonth()) * parseFloat(this.usina_detalhes.usp_rsi_mar)
      let abr = parseFloat(moment(4, 'MM').daysInMonth()) * parseFloat(this.usina_detalhes.usp_rsi_abr)
      let mai = parseFloat(moment(5, 'MM').daysInMonth()) * parseFloat(this.usina_detalhes.usp_rsi_mai)
      let jun = parseFloat(moment(6, 'MM').daysInMonth()) * parseFloat(this.usina_detalhes.usp_rsi_jun)
      let jul = parseFloat(moment(7, 'MM').daysInMonth()) * parseFloat(this.usina_detalhes.usp_rsi_jul)
      let ago = parseFloat(moment(8, 'MM').daysInMonth()) * parseFloat(this.usina_detalhes.usp_rsi_ago)
      let set = parseFloat(moment(9, 'MM').daysInMonth()) * parseFloat(this.usina_detalhes.usp_rsi_set)
      let out = parseFloat(moment(10, 'MM').daysInMonth()) * parseFloat(this.usina_detalhes.usp_rsi_out)
      let nov = parseFloat(moment(11, 'MM').daysInMonth()) * parseFloat(this.usina_detalhes.usp_rsi_nov)
      let dez = parseFloat(moment(12, 'MM').daysInMonth()) * parseFloat(this.usina_detalhes.usp_rsi_dez)
      let retorno = parseFloat(jan) + parseFloat(fev) + parseFloat(mar) + parseFloat(abr) + parseFloat(mai) + parseFloat(jun) + parseFloat(jul) + parseFloat(ago) + parseFloat(set) + parseFloat(out) + parseFloat(nov) + parseFloat(dez)
      return retorno
    },
    geracaoAnualObjetivoMinimo (usina) {
      const jan = parseFloat(usina.projeto.usp_objetivo_minimo_jan) || 0
      const fev = parseFloat(usina.projeto.usp_objetivo_minimo_fev) || 0
      const mar = parseFloat(usina.projeto.usp_objetivo_minimo_mar) || 0
      const abr = parseFloat(usina.projeto.usp_objetivo_minimo_abr) || 0
      const mai = parseFloat(usina.projeto.usp_objetivo_minimo_mai) || 0
      const jun = parseFloat(usina.projeto.usp_objetivo_minimo_jun) || 0
      const jul = parseFloat(usina.projeto.usp_objetivo_minimo_jul) || 0
      const ago = parseFloat(usina.projeto.usp_objetivo_minimo_ago) || 0
      const set = parseFloat(usina.projeto.usp_objetivo_minimo_set) || 0
      const out = parseFloat(usina.projeto.usp_objetivo_minimo_out) || 0
      const nov = parseFloat(usina.projeto.usp_objetivo_minimo_nov) || 0
      const dez = parseFloat(usina.projeto.usp_objetivo_minimo_dez) || 0
      const result = jan + fev + mar + abr + mai + jun + jul + ago + set + out + nov + dez
      return result ? result.toFixed(2) : '-'
    },
    geracaoAnualPrevista () {
      let jan = this.returnvalorRSIMes(this.usina_detalhes.usp_rsi_jan, 1)
      let fev = this.returnvalorRSIMes(this.usina_detalhes.usp_rsi_fev, 2)
      let mar = this.returnvalorRSIMes(this.usina_detalhes.usp_rsi_mar, 3)
      let abr = this.returnvalorRSIMes(this.usina_detalhes.usp_rsi_abr, 4)
      let mai = this.returnvalorRSIMes(this.usina_detalhes.usp_rsi_mai, 5)
      let jun = this.returnvalorRSIMes(this.usina_detalhes.usp_rsi_jun, 6)
      let jul = this.returnvalorRSIMes(this.usina_detalhes.usp_rsi_jul, 7)
      let ago = this.returnvalorRSIMes(this.usina_detalhes.usp_rsi_ago, 8)
      let set = this.returnvalorRSIMes(this.usina_detalhes.usp_rsi_set, 9)
      let out = this.returnvalorRSIMes(this.usina_detalhes.usp_rsi_out, 10)
      let nov = this.returnvalorRSIMes(this.usina_detalhes.usp_rsi_nov, 11)
      let dez = this.returnvalorRSIMes(this.usina_detalhes.usp_rsi_dez, 12)
      let retorno = parseFloat(jan) +
                      parseFloat(fev) +
                      parseFloat(mar) + parseFloat(abr) + parseFloat(mai) + parseFloat(jun) + parseFloat(jul) + parseFloat(ago) + parseFloat(set) + parseFloat(out) + parseFloat(nov) + parseFloat(dez)
      this.geracaoPrevista = retorno.toFixed(2)
      return retorno.toFixed(2)
    },
    returnvalorRSIMes (valor, mes, potencia = null, eficiencia = null) {
      if (!potencia) {
        potencia = this.usina_detalhes.usp_potencia
      }

      if (!eficiencia) {
        eficiencia = this.usina_detalhes.usp_eficiencia
      }

      if (valor && potencia) {
        let retorno = parseFloat(potencia.replace(',', '.')) * parseFloat(valor.replace(',', '.')) * parseFloat(moment(mes, 'MM').daysInMonth()) * (parseFloat(eficiencia.replace(',', '.')) / 100)
        return retorno.toFixed(2)
      } else {
        return ''
      }
    },
    returnvalorRSIPorcentagem (valor, mes) {
      if (valor && this.usina_detalhes.usp_eficiencia) {
        let dado = this.returnvalorRSIMes(valor, mes) / this.geracaoPrevista
        let info = (dado * 100)
        return info.toFixed(2) + '%'
      } else {
        return ''
      }
    },
    editDetalhesUsina () {
      this.salvando = true
      Api.post('usinas/' + this.usina.uuid_usi_id + '/projeto/edita', this.usina_detalhes)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.closeDialogUsina()
          this.closeDialogDetalhesUsina()
          this.getUsinas()
          this.$root.SnackControl.open(this, {
            text: 'Dados atualizados com sucesso!',
            color: 'success'
          })
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao atualizar os dados da usina!',
            color: 'error'
          })
        })
    },
    closeDialogDetalhesUsina () {
      this.usina_detalhes = {
        usp_potencia: '',
        usp_eficiencia: '',
        usp_data_instalacao: '',
        usp_total_investido: '',
        usp_tarifa_referencia: '',
        rsiSelect: '',
        usp_rsi_jan: '',
        usp_rsi_fev: '',
        usp_rsi_mar: '',
        usp_rsi_abr: '',
        usp_rsi_mai: '',
        usp_rsi_jun: '',
        usp_rsi_jul: '',
        usp_rsi_ago: '',
        usp_rsi_set: '',
        usp_rsi_out: '',
        usp_rsi_nov: '',
        usp_rsi_dez: '',
        uuid_uss_id: ''
      }
      if (this.$refs.formUsinaDetalhes) {
        this.$refs.formUsinaDetalhes.resetValidation()
      }
      this.dialogUsina = false
    },
    validaCorDesempenho (desempenho, tipo) {
      if (desempenho === '-') {
        return ''
      }

      if (typeof desempenho === 'string') {
        desempenho = Number(desempenho.replace(',', '.'))
      }
      if (desempenho >= 67) {
        return `${tipo}-green`
      }
      if (desempenho >= 33) {
        return `${tipo}-yellow`
      }
      return `${tipo}-red`
    },
    generateColor () {
      const letters = '0123456789ABCDEF'
      let color = '#'

      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
      }

      return color
    }
  },
  created () {
    this.loadContent()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.mw_usina {
  max-width: 450px;
}
.td_table {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
}
>>> {
  td {
    padding: 0!important;
  }
}
.value_area {
  font-size: 14px;
  font-weight: bold;
  line-height: normal;
  margin-top: 3px;
  text-align: right;
}
.value_area_porcentagem {
  font-size: 14px;
  line-break: normal;
  text-align: right;
}
.consulta {
  margin-bottom: 2px;
  min-height: 39px!important;
  width: 100%!important;
}
.add_gerador {
  margin-bottom: 3px;
}
.avatar {
  background-position: center top;
  background-repeat: no-repeat;
  background-size: cover;
  height: 150px;
  margin-right: 15px;
  width: 150px;
}
.v-file-input {
  >>>.v-input__prepend-outer {
    margin-top: 10px!important;
  }
}
.full_width {
  min-width: 450px!important;
  @media (max-width: 991px){
    min-width: 100%!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/relatorios/AcompanhamentoUsina.vue